import { http } from './http';

export const getModel = id => http.get(`model/${id}`);
